import { render, staticRenderFns } from "./CommandsView.vue?vue&type=template&id=495840ee"
import script from "./CommandsView.vue?vue&type=script&lang=js"
export * from "./CommandsView.vue?vue&type=script&lang=js"
import style0 from "./CommandsView.vue?vue&type=style&index=0&id=495840ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports